import CTNDropdownButton from '@ctn/ui/components/ctn-dropdown-button';
import CTNEllipsis from '@ctn/ui/components/ctn-ellipsis';

import { type ILookup } from '@/interfaces/model/generic.interface';
import type { ISolicitud } from '@/interfaces/model/solicitudes.interface';
import type { CustomColumnDef } from '@ctn/ui/types/ctn-table';

const getColumns = ({
	tipoTramite = [],
	eliminar,
	goToDetail,
}: {
	tipoTramite: ILookup[];
	eliminar: (value: ISolicitud) => void;
	goToDetail: (value: ISolicitud) => void;
}) => {
	const columns: Array<CustomColumnDef<ISolicitud>> = [
		{
			accessorKey: 'numeroTramiteExterno',
			header: 'Nº solicitud',
			enableSorting: false,
			th: {
				width: 164,
			},
			responsive: {
				sizeColumn: 'full'
			},
			cell: ({ getValue }) => <CTNEllipsis content={getValue() as string} />,
		},
		{
			accessorKey: 'fechaCreacion',
			header: 'Fecha',
			enableSorting: false,
			th: {
				width: 164,
			},
			responsive: {
				sizeColumn: 'full'
			},
			cell: ({ getValue }) => <CTNEllipsis content={getValue() as string} />,
		},
		{
			accessorKey: 'tipoTramite',
			header: 'Tipo de negocio jurídico',
			enableSorting: false,
			responsive: {
				sizeColumn: 'full'
			},

			cell({ getValue }) {
				const value = getValue() as ISolicitud['tipoTramite'];
				return (
					<CTNEllipsis
						content={value ? tipoTramite.find((data) => data?.id === value.id)?.descripcion : ''}
					/>
				);
			},
		},
		{
			accessorKey: 'actions',
			header: '',
			enableSorting: false,
			th: {
				width: 48,
			},
			td: {
				align: 'center',
			},
			responsive: { sizeColumn: 'full' },
			cell: ({ row }) => (
				<CTNDropdownButton
					variant="ghost"
					mode="secondary"
					size="size-32"
					label="Acciones"
					icon={[{ icon: 'moreVertical', color: 'none', position: 'left' }]}
					items={[
						{ label: 'Editar', onClick: () => goToDetail(row.original) },
						{ label: 'Eliminar', onClick: () => eliminar(row.original) },
					]}
				/>
			),
		},
	];

	return columns;
};

export default getColumns;
